const DocumentIcon = () => (
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6401 2.61104C17.2061 2.17705 16.4546 2.47344 16.4546 3.07679V6.77101C16.4546 8.31644 17.7671 9.59724 19.3655 9.59724C20.3711 9.60783 21.7683 9.60783 22.9645 9.60783C23.5678 9.60783 23.8854 8.89862 23.462 8.47521C21.9377 6.94037 19.2067 4.17765 17.6401 2.61104Z"
      fill="#585E66"
    />
    <path
      d="M22.6158 11.0577H19.5567C17.048 11.0577 15.005 9.01473 15.005 6.50605V3.44694C15.005 2.86476 14.5287 2.38843 13.9465 2.38843H9.45842C6.1982 2.38843 3.5625 4.50546 3.5625 8.28435V17.6628C3.5625 21.4417 6.1982 23.5587 9.45842 23.5587H17.7783C21.0386 23.5587 23.6743 21.4417 23.6743 17.6628V12.1162C23.6743 11.534 23.1979 11.0577 22.6158 11.0577ZM13.0891 19.06H8.85507C8.42108 19.06 8.06119 18.7001 8.06119 18.2661C8.06119 17.8322 8.42108 17.4723 8.85507 17.4723H13.0891C13.5231 17.4723 13.883 17.8322 13.883 18.2661C13.883 18.7001 13.5231 19.06 13.0891 19.06ZM15.2062 14.826H8.85507C8.42108 14.826 8.06119 14.4661 8.06119 14.0321C8.06119 13.5981 8.42108 13.2382 8.85507 13.2382H15.2062C15.6401 13.2382 16 13.5981 16 14.0321C16 14.4661 15.6401 14.826 15.2062 14.826Z"
      fill="#585E66"
    />
  </svg>
);

export default DocumentIcon;
